export enum OperationStatus {
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  REJECTED = 'REJECTED',
  REVERTED = 'REVERTED',
  ERROR = 'ERROR',
}
